<template>
  <div id="vdo-set-unit-editor">
    <div class="-header">
      <div class="--title">
        <span>Add Exam</span>
      </div>
      <span class="--subtitle">เพิ่มข้อสอบ</span>
    </div>

    <div class="-body">
      <!-- <div class="--item-container"
        v-if="courseOutlineOptions.length > 0"
      >
        <div class="--title"><span>เลือกวิชาจาก Course Outline</span></div>
        <div class="--item" v-for="(item) in courseOutlineRemainOptions" :key="item.id">
          <vx-card>
            <vs-row vs-type="flex" vs-justify="center">
              <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" style="width: 32px; margin-right: 10px; margin-left: -30px">
                <vs-checkbox v-model="input" :vs-value="item" />
              </vs-col>
              
              <vs-col vs-w="6" vs-type="flex" vs-justify="flex-start" vs-align="center">
                <span><strong>{{ item.subject.code }} </strong> {{ item.subject.nameLocal }}</span>
              </vs-col>
              
              <vs-col vs-w="5" vs-type="flex" vs-justify="flex-end" vs-align="center">
                <span><strong>อาจารย์ </strong> {{ item.teacher | teacherName }}</span>
              </vs-col>
            </vs-row>
          </vx-card>
        </div>
      </div>
      <div v-else>
        ยังไม่มี Course Outline สำหรับกลุ่มวิชานี้
      </div> -->
      <!-- {{ form.filter }} -->
      <div class="--controllers">
        <vs-button
          @click="save"
        >
          <!-- :disabled="!isAvailableToCreate" -->
          Save
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, vue/no-unused-components */
import { state } from "../data";
import { loadData } from '../data/data-loader';
import { submitForm } from "../data/data-handlers";
// import { transformCheckboxInputToCourseOutlineRegistrationInput } from "../data/data-modellers";
import Block from "@/components/common-ui/block/index.vue";
import InputBox from "@/components/common-ui/forms/input-box/index.vue";
import TextArea from "@/components/common-ui/forms/textarea/index.vue";
import SelectBox from "@/components/common-ui/forms/select-box/index.vue";

export default {
  components: {
    Block
  },
  data() {
    return {
      local: state.local,
      store: state.store,
      selection: state.local.filterSelection,
      form: state.local.form,
      list: state.local.list,
      input: [],
    }
  },
  computed: {
    subjectOptions() {
      return state.local.selectorOptions.subject;
    },
    courseOutlineOptions() {
      return state.local.selectorOptions.courseOutline;
    },
    courseOutlineRemainOptions() {
      // console.log(this.list);
      const used = this.list.map(item => item.courseOutline.id);
      // console.log("used", used);
      const remain = state.local.selectorOptions.courseOutline.filter(item => {
        // console.log(item);
        return !used.includes(item.id);
      })
      // console.log(remain);
      return remain;
    }
  },
  methods: {
    handleCourseOutlineUnitSelect(data) {
      this.form.courseOutlineUnitId = data.multipleValues.courseOutlineUnitId;
      this.form.vdoSetUnitInput.unitSeq = data.multipleValues.unitSeq;
    },
    handleRemarkInput({ data }) {
      this.form.vdoSetUnitInput.remark = data;
    },
    async save() {
      const payload = {
        degreeId: this.form.filter.degreeId,
        subjectGroupId: this.form.filter.subjectGroupId,
        subjectId: this.form.filter.subjectId,
        teacherId: this.form.filter.teacherId,
      };
      const result = await submitForm(payload);
      if (result.status.success) {
        alert("Add new Course Outline Registration success");
        this.local.editor = { active: false };
        loadData();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// @import "common-scoped";

.editor #vdo-set-unit-editor {
  width: 100%;
  height: 100%;
  padding-bottom: 100px;

  & .-header {
    width: 100%;
    display: block;
    margin-bottom: 20px;

    & .--title {
      font-size: 2rem;
      color: #6f66b9;
      padding-bottom: 1rem;
      width: 100%;
      height: 3rem;
      border-bottom: 2px solid #e8e8e8;
    }
    & .--subtitle {
      margin-top: 1rem;
      font-size: 1rem;
    }
  }

  & .-body {
    display: flex;
    width: 100%;
    flex-direction: column;

    & .--title {
      margin-bottom: 20px;
      margin-top: 20px;
      text-align: center;

      & > span {
        font-size: 1.4rem;
        font-weight: 400;
      }
    }

    & .--item-container {
      display: block;
      width: 100%;

      & .--item {
        display: block;
        width: 100%;
        margin-bottom: 10px;
      }
    }

    & .--controllers {
      margin-top: 20px;
    }
  }
}
</style>
